import React from 'react';
import { DI } from '../../../../src/Core';
import ListingGrid from '../Listing Grid/ListingGrid';

function Bulkedit(props: any) {
    return (
        <div>
            <ListingGrid
                bulkedit={true}
                selectedRows={props?.location?.state?.selectedRows ?? []}
            />
        </div>
    );
}

export default DI(Bulkedit);
